<template>
  <div class="download-page-wrapper">
    <section class="download-page">
      <!-- Mobile-only logo that appears at the top of the screen -->
      <img src="@/assets/logo.png" class="download-page__mobile-logo" alt="logo" />

      <div class="download-page__container">
        <!-- Left Panel - Image and Title (hidden on mobile) -->
        <ImagePanel />

        <!-- Right Panel - Download Form -->
        <DownloadForm :share-id="shareId" />
      </div>
    </section>
  </div>
</template>

<script>
import ImagePanel from '@/components/auth/login/ImagePanel.vue';
import DownloadForm from '@/components/share/DownloadForm.vue';

export default {
  name: 'DownloadSharePage',

  components: {
    ImagePanel,
    DownloadForm
  },

  computed: {
    shareId() {
      return this.$route.params.hashCode; // Keep hashCode param name for compatibility with route
    }
  },

  // Add route validation to ensure share ID exists
  beforeRouteEnter(to, from, next) {
    if (!to.params.hashCode) {
      next('/404');
    } else {
      next();
    }
  }
};
</script>

<style lang="scss" scoped>
.download-page-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9999;
  background-color: var(--main-bg-color);
}

.download-page {
  display: flex;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  background-color: var(--main-bg-color);
  position: relative;

  // Mobile-only logo that sits outside any panels
  &__mobile-logo {
    display: none;
    height: 40px;
    position: absolute;
    top: 24px;
    left: 24px;
    z-index: 10;

    @media (max-width: 768px) {
      display: block;
    }
  }

  &__container {
    display: flex;
    width: 100%;
    max-width: 1440px;
    margin: 0 auto;
    padding: 0 40px;
    gap: 32px;

    @media (max-width: 1200px) {
      padding: 0 24px;
      gap: 24px;
    }

    @media (max-width: 768px) {
      flex-direction: column;
      padding: 0;
      gap: 0;
    }

    @media (max-width: 480px) {
      padding: 0;
    }
  }
}
</style>
